import React, { useEffect, useRef, useState } from "react";
import lottie from "lottie-web";

import { PopupButton } from "@typeform/embed-react";

import Cover from "../components/cover";
import { primary } from "../constants/colors";
import { useTranslate } from "../contexts/translate";

import {
	GigaTitle,
	LargeHeading,
	LargeText,
	MediumTitle,
	SmallHeading,
	SmallTitle,
} from "../ui-components/texts";
import {
	Column,
	Container,
	ContainerBlock,
} from "../ui-components/columns/components";
import { FullHeightSection } from "../ui-components/sections";
import { icons } from "../ui-components/icons-manager";

import imageTopCover from "../media/images/approach-page/1.jpg";
import imageBottomCover from "../media/images/approach-page/2.jpg";

import build from "../media/animations/build.json";
import grow from "../media/animations/grow.json";
import transform from "../media/animations/transform.json";
import { deviceType, touchWork } from "../utils";
import { useThemeContext } from "../utils/theme-context";

const Approach = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	const { translations } = useTranslate();
	const squaresContent = useRef();

	const {
		setColorIconDark,
		setColorLangDark,
		setColorScrollDark,
		setColorArrowDark,
		setColorNeedHelpDark,
	} = useThemeContext();

	const [classSquare, setClassSquare] = useState([
		"d-none",
		"d-none",
		"d-none",
		"d-none",
	]);
	const [indexTexts, setIndexTexts] = useState(0);
	const [textClassName, setTextClassName] = useState("text-animation");
	const [classWrapperFull, setClassWrapperFull] = useState(
		"align-center-items-d-flex theme-light mid-padding block-scroll-body light-section"
	);
	const [detectedScroll, setDetectedScroll] = useState(-1);
	const [reverse, setReverse] = useState(false);

	useEffect(() => {
		document.querySelector("body").style.overflow = "auto";
		setTimeout(() => {
			lottie.loadAnimation({
				container: document.querySelector("#build-animation"),
				loop: true,
				autoplay: true,
				animationData: build,
			});
		}, 2000);

		setTimeout(() => {
			lottie.loadAnimation({
				container: document.querySelector("#grow-animation"),
				loop: true,
				autoplay: true,
				animationData: grow,
			});
		}, 3000);

		setTimeout(() => {
			lottie.loadAnimation({
				container: document.querySelector("#transform-animation"),
				loop: true,
				autoplay: true,
				animationData: transform,
			});
		}, 4000);
	}, []);

	useEffect(() => {
		setNextPageHref("/services");
		setNextPageName(
			translations === null ? "" : translations.navbar.links.services
		);
		document.title = "Approach - Cutting Edge Digital Creative Studio";
	}, [translations]);

	const handleGoNext = async (desktop = false) => {
		if (indexTexts !== 4 && desktop) setTextClassName("close-text-animation");

		setTimeout(() => {
			if (indexTexts === 0) {
				setIndexTexts(1);
				setClassSquare([
					"d-block swashIn",
					"d-none swashOut",
					"d-none swashOut",
					"d-none swashOut",
				]);
			}
			if (indexTexts === 1) {
				setIndexTexts(2);
				setClassSquare([
					"opacity-0 swashOut",
					"d-block swashIn",
					"d-none swashOut",
					"d-none swashOut",
				]);
			}
			if (indexTexts === 2) {
				setIndexTexts(3);
				setClassSquare([
					"d-none swashOut",
					"opacity-0 swashOut",
					"d-block swashIn",
					"d-none swashOut",
				]);
			}
			if (indexTexts === 3) {
				setIndexTexts(4);
				setClassSquare([
					"d-none swashOut",
					"d-none swashOut",
					"opacity-0 swashOut",
					"d-block swashIn",
				]);
			}
			if (indexTexts === 4) {
				if (!desktop) return setIndexTexts(0);

				setClassSquare([
					"d-none swashOut",
					"d-none swashOut",
					"d-none swashOut",
					"opacity-0 swashOut",
				]);

				if (desktop) {
					setTimeout(() => {
						setTextClassName("text-animation");
						setClassWrapperFull(
							"align-center-items-d-flex theme-light approach-animation mid-padding light-section"
						);

						document.querySelector("body").removeAttribute("style");
						document
							.querySelector(".approach-animation")
							.removeAttribute("style");

						document.querySelector(".approach-animation").style.background =
							"#fff";

						setTimeout(() => {
							window.scrollTo(
								0,
								document.querySelector(".cta-single-project").offsetTop
							);

							window.addEventListener("scroll", (e) => {
								window.scrollY = e.target.documentElement.scrollTop;
							});

							setColorIconDark(false);
							setColorLangDark(false);
							setColorScrollDark(false);
							setColorArrowDark(false);
							setColorNeedHelpDark(false);
						}, 200);
					}, 100);

					return;
				}
			}

			setTextClassName("text-animation");
		}, 300);

		window.removeEventListener("scroll", () => {});
	};

	const handleGoPrev = async (desktop = false) => {
		if (indexTexts === 0) {
			return;
		}

		setTextClassName("close-text-animation");

		setTimeout(() => {
			if (indexTexts === 4) {
				setIndexTexts(3);
				setClassSquare([
					"d-none swashOut",
					"d-none swashOut",
					"d-block swashIn",
					"opacity-0 swashOut",
				]);
				setTextClassName("text-animation");
				return;
			}
			if (indexTexts === 3) {
				setIndexTexts(2);
				setClassSquare([
					"d-none swashOut",
					"d-block swashIn",
					"opacity-0 swashOut",
					"d-none swashOut",
				]);
				setTextClassName("text-animation");
				return;
			}
			if (indexTexts === 2) {
				setIndexTexts(1);
				setClassSquare([
					"d-block swashIn",
					"opacity-0 swashOut",
					"d-none swashOut",
					"d-none swashOut",
				]);
				setTextClassName("text-animation");
				return;
			}
			if (indexTexts === 1) {
				setIndexTexts(0);
				setClassSquare([
					"opacity-0 swashOut",
					"d-none swashOut",
					"d-none swashOut",
					"d-none swashOut",
				]);
				setTextClassName("text-animation");
				return;
			}
		}, 300);
	};

	useEffect(() => {
		if (deviceType() === "desktop") return;
		if (!touchWork()) return;

		if (deviceType() === "mobile") {
			squaresContent.current.style.transform = `translateX(-${
				indexTexts * 100 - 100
			}%)`;
		}
	}, [indexTexts]);

	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (document.querySelector(".block-scroll-body") === null) return;

			if (
				window.scrollY >= document.querySelector(".block-scroll-body").offsetTop
			) {
				window.scrollY = document.querySelector(".block-scroll-body").offsetTop;

				document.querySelector("body").style.overflow = "hidden";

				document.querySelector(".block-scroll-body").style.position = "fixed";
				document.querySelector(".block-scroll-body").style.top = 0;
				document.querySelector(".block-scroll-body").style.bottom = 0;
				document.querySelector(".block-scroll-body").style.right = 0;
				document.querySelector(".block-scroll-body").style.left = 0;

				setColorIconDark(true);
				setColorLangDark(true);
				setColorScrollDark(true);
				setColorArrowDark(true);
				setColorNeedHelpDark(true);
			}
		});

		if (deviceType() !== "desktop") return;
		if (touchWork()) return;

		window.addEventListener("wheel", (e) => {
			if (document.querySelector(".block-scroll-body") === null) return;

			if (
				detectedScroll === -1 &&
				e.deltaY >= 100 &&
				window.scrollY >=
					document.querySelector(".block-scroll-body").offsetTop - 5
			) {
				setDetectedScroll(0);
			}

			if (
				detectedScroll === -1 &&
				e.deltaY <= -100 &&
				window.scrollY >=
					document.querySelector(".block-scroll-body").offsetTop - 5
			) {
				setDetectedScroll(1);
			}
		});

		return function cleanup() {
			window.removeEventListener("scroll", () => {});
			window.removeEventListener("wheel", () => {});
		};
	}, [indexTexts]);

	useEffect(() => {
		if (detectedScroll === -1) return;
		setDetectedScroll(-1);

		setTimeout(() => {
			if (detectedScroll === 0) handleGoNext(true);
			if (detectedScroll === 1) handleGoPrev(true);
		}, 150);
	}, [detectedScroll, reverse]);

	return (
		<section className="approach-page-component">
			<Cover imageTop={imageBottomCover} imageBottom={imageTopCover}>
				<GigaTitle className="min-line-height">
					<span className="text-animation animation-delay-05s">
						We can face
					</span>
					<span className="text-animation animation-delay-05s">
						any challenge,
					</span>
					<span className="text-animation animation-delay-05s">together.</span>
				</GigaTitle>
			</Cover>

			<section className="theme-light mid-padding light-section">
				<ContainerBlock className="mid">
					<SmallTitle className="small-bottom-padding">
						{translations === null ? "" : translations.approach.section1}
					</SmallTitle>

					<Container className="two-column-component">
						<div className="wrapper align-items-center">
							<Column
								className={`w-15 svg-max-width-animation w-phone-50 p-sm-10px`}
							>
								<div id="build-animation"></div>
							</Column>
							<Column className="w-85 w-phone-100">
								<LargeHeading>
									{translations === null
										? ""
										: translations.approach.items[0].title}
								</LargeHeading>
								<SmallHeading>
									{translations === null
										? ""
										: translations.approach.items[0].text}
								</SmallHeading>
							</Column>
						</div>
					</Container>

					<Container className="two-column-component">
						<div className="wrapper align-items-center">
							<Column
								className={`w-15 svg-max-width-animation w-phone-50 p-sm-10px`}
							>
								<div id="grow-animation"></div>
							</Column>
							<Column className="w-85 w-phone-100">
								<LargeHeading>
									{translations === null
										? ""
										: translations.approach.items[1].title}
								</LargeHeading>
								<SmallHeading>
									{translations === null
										? ""
										: translations.approach.items[1].text}
								</SmallHeading>
							</Column>
						</div>
					</Container>

					<Container className="two-column-component">
						<div className="wrapper align-items-center">
							<Column
								className={`w-15 svg-max-width-animation w-phone-50 p-sm-10px`}
							>
								<div id="transform-animation"></div>
							</Column>
							<Column className="w-85 w-phone-100">
								<LargeHeading>
									{translations === null
										? ""
										: translations.approach.items[2].title}
								</LargeHeading>
								<SmallHeading>
									{translations === null
										? ""
										: translations.approach.items[2].text}
								</SmallHeading>
							</Column>
						</div>
					</Container>
				</ContainerBlock>
			</section>

			<section
				className="theme-dark small-padding"
				style={{ background: primary }}
			>
				<div className="approach-images">
					<img
						className="w-100"
						src={require("../media/images/approach.jpg").default}
					/>
				</div>
			</section>

			<FullHeightSection
				id="we-work"
				as={"section"}
				style={{ background: "#fff" }}
				className={classWrapperFull}
			>
				<ContainerBlock className="mid h-auto">
					<MediumTitle className={textClassName}>
						{translations === null
							? ""
							: translations.approach.animationSquares[indexTexts].title}
					</MediumTitle>
					<LargeText className={`mt-3 mb-0 ${textClassName}`}>
						{translations === null
							? ""
							: translations.approach.animationSquares[indexTexts].description}
					</LargeText>

					<div className="squares position-relative" ref={squaresContent}>
						<svg
							width="312"
							height="312"
							viewBox="0 0 312 312"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								style={{ animationDuration: ".5s" }}
								d="M156.396 0.39624L312 156L156.396 311.604L0.79248 156L156.396 0.39624Z"
								fill="#E64BAF"
								opacity={1}
								className={classSquare[0]}
							/>
							<path
								d="M149.12 6.87973L153.443 2.5574L154.15 3.26451L155.604 1.81046L157.058 3.26448L157.765 2.55738L162.087 6.87971L161.38 7.58682L165.703 11.9091L166.41 11.202L170.732 15.5244L170.025 16.2315L174.347 20.5538L175.054 19.8467L179.377 24.169L178.67 24.8761L182.992 29.1985L183.699 28.4914L188.021 32.8137L187.314 33.5208L191.637 37.8431L192.344 37.136L196.666 41.4584L195.959 42.1655L200.281 46.4878L200.988 45.7807L205.311 50.103L204.604 50.8101L208.926 55.1325L209.633 54.4254L213.955 58.7477L213.248 59.4548L217.571 63.7771L218.278 63.07L222.6 67.3924L221.893 68.0995L226.215 72.4218L226.922 71.7147L231.245 76.037L230.538 76.7441L234.86 81.0665L235.567 80.3593L239.889 84.6817L239.182 85.3888L243.504 89.7111L244.212 89.004L248.534 93.3263L247.827 94.0334L252.149 98.3558L252.856 97.6487L257.179 101.971L256.471 102.678L260.794 107L261.501 106.293L265.823 110.616L265.116 111.323L269.438 115.645L270.146 114.938L274.468 119.26L273.761 119.967L278.083 124.29L278.79 123.583L283.113 127.905L282.405 128.612L286.728 132.934L287.435 132.227L291.757 136.55L291.05 137.257L295.372 141.579L296.08 140.872L300.402 145.194L299.695 145.901L304.017 150.224L304.724 149.517L309.047 153.839L308.339 154.546L309.793 156L308.339 157.454L309.047 158.161L304.724 162.484L304.017 161.776L299.695 166.099L300.402 166.806L296.08 171.128L295.372 170.421L291.05 174.743L291.757 175.451L287.435 179.773L286.728 179.066L282.405 183.388L283.113 184.095L278.79 188.418L278.083 187.71L273.761 192.033L274.468 192.74L270.146 197.062L269.438 196.355L265.116 200.677L265.823 201.385L261.501 205.707L260.794 205L256.471 209.322L257.179 210.029L252.856 214.352L252.149 213.644L247.827 217.967L248.534 218.674L244.212 222.996L243.504 222.289L239.182 226.611L239.889 227.319L235.567 231.641L234.86 230.934L230.537 235.256L231.245 235.963L226.922 240.286L226.215 239.578L221.893 243.901L222.6 244.608L218.278 248.93L217.57 248.223L213.248 252.545L213.955 253.252L209.633 257.575L208.926 256.868L204.604 261.19L205.311 261.897L200.988 266.219L200.281 265.512L195.959 269.835L196.666 270.542L192.344 274.864L191.637 274.157L187.314 278.479L188.021 279.186L183.699 283.509L182.992 282.802L178.67 287.124L179.377 287.831L175.054 292.153L174.347 291.446L170.025 295.769L170.732 296.476L166.41 300.798L165.703 300.091L161.38 304.413L162.087 305.12L157.765 309.443L157.058 308.736L155.604 310.19L154.15 308.736L153.443 309.443L149.12 305.12L149.827 304.413L145.505 300.091L144.798 300.798L140.476 296.476L141.183 295.769L136.86 291.446L136.153 292.153L131.831 287.831L132.538 287.124L128.216 282.802L127.509 283.509L123.186 279.186L123.893 278.479L119.571 274.157L118.864 274.864L114.542 270.542L115.249 269.835L110.926 265.512L110.219 266.219L105.897 261.897L106.604 261.19L102.282 256.868L101.575 257.575L97.2524 253.252L97.9595 252.545L93.6372 248.223L92.9301 248.93L88.6077 244.608L89.3148 243.901L84.9925 239.578L84.2854 240.285L79.9631 235.963L80.6702 235.256L76.3478 230.934L75.6407 231.641L71.3184 227.318L72.0255 226.611L67.7032 222.289L66.9961 222.996L62.6738 218.674L63.3809 217.967L59.0585 213.644L58.3514 214.352L54.0291 210.029L54.7362 209.322L50.4139 205L49.7068 205.707L45.3844 201.385L46.0916 200.677L41.7692 196.355L41.0621 197.062L36.7398 192.74L37.4469 192.033L33.1246 187.71L32.4175 188.418L28.0951 184.095L28.8022 183.388L24.4799 179.066L23.7728 179.773L19.4505 175.451L20.1576 174.743L15.8353 170.421L15.1282 171.128L10.8058 166.806L11.5129 166.099L7.1906 161.776L6.48349 162.484L2.16116 158.161L2.86827 157.454L1.41422 156L2.86824 154.546L2.16114 153.839L6.48347 149.517L7.19058 150.224L11.5129 145.901L10.8058 145.194L15.1281 140.872L15.8352 141.579L20.1576 137.257L19.4505 136.55L23.7728 132.227L24.4799 132.934L28.8022 128.612L28.0951 127.905L32.4175 123.583L33.1246 124.29L37.4469 119.967L36.7398 119.26L41.0621 114.938L41.7692 115.645L46.0916 111.323L45.3845 110.616L49.7068 106.293L50.4139 107L54.7362 102.678L54.0291 101.971L58.3515 97.6486L59.0586 98.3557L63.3809 94.0334L62.6738 93.3263L66.9961 89.004L67.7032 89.7111L72.0256 85.3887L71.3185 84.6816L75.6408 80.3593L76.3479 81.0664L80.6702 76.7441L79.9631 76.037L84.2854 71.7146L84.9925 72.4218L89.3149 68.0994L88.6078 67.3923L92.9301 63.07L93.6372 63.7771L97.9595 59.4548L97.2524 58.7477L101.575 54.4253L102.282 55.1324L106.604 50.8101L105.897 50.103L110.219 45.7807L110.926 46.4878L115.249 42.1655L114.542 41.4584L118.864 37.136L119.571 37.8431L123.893 33.5208L123.186 32.8137L127.509 28.4914L128.216 29.1985L132.538 24.8762L131.831 24.1691L136.153 19.8467L136.86 20.5538L141.183 16.2315L140.476 15.5244L144.798 11.2021L145.505 11.9092L149.827 7.58684L149.12 6.87973Z"
								stroke="#1A1A1A"
								strokeWidth="2"
								strokeDasharray="6 6"
							/>
							<path
								opacity="1"
								d="M106.576 165.355H111.856C116.536 165.355 120.4 162.499 120.4 156.955C120.4 151.411 116.536 148.555 111.856 148.555H106.576V165.355ZM109.336 162.883V151.003H111.664C114.688 151.003 117.52 152.659 117.52 156.955C117.52 161.251 114.688 162.883 111.664 162.883H109.336ZM124.112 151.243C125.096 151.243 125.84 150.499 125.84 149.563C125.84 148.603 125.096 147.859 124.112 147.859C123.152 147.859 122.432 148.603 122.432 149.563C122.432 150.499 123.152 151.243 124.112 151.243ZM122.816 165.355H125.432V153.259H122.816V165.355ZM132.71 165.547C135.446 165.547 137.27 163.939 137.27 161.851C137.27 156.883 130.478 158.659 130.478 156.331C130.478 155.539 131.198 155.083 132.35 155.083C133.454 155.083 134.582 155.755 134.894 156.955L137.054 156.043C136.526 154.267 134.606 153.067 132.326 153.067C129.71 153.067 128.054 154.483 128.054 156.379C128.054 160.963 134.798 159.259 134.798 161.875C134.798 162.739 133.958 163.459 132.71 163.459C131.03 163.459 130.094 162.379 129.686 161.083L127.526 161.995C128.078 163.723 129.758 165.547 132.71 165.547ZM144.974 165.547C147.926 165.547 150.014 164.035 150.518 161.515L147.95 161.011C147.662 162.427 146.582 163.267 145.046 163.267C142.982 163.267 141.614 161.707 141.614 159.307C141.614 156.907 142.958 155.347 145.046 155.347C146.582 155.347 147.71 156.283 147.95 157.651L150.494 157.147C150.086 154.651 147.95 153.067 144.974 153.067C141.35 153.067 138.902 155.587 138.902 159.307C138.902 163.027 141.35 165.547 144.974 165.547ZM158.478 165.547C162.102 165.547 164.718 162.931 164.718 159.307C164.718 155.683 162.102 153.067 158.478 153.067C154.83 153.067 152.238 155.683 152.238 159.307C152.238 162.931 154.83 165.547 158.478 165.547ZM158.478 163.267C156.318 163.267 154.878 161.635 154.878 159.307C154.878 156.979 156.318 155.347 158.478 155.347C160.614 155.347 162.078 156.979 162.078 159.307C162.078 161.635 160.614 163.267 158.478 163.267ZM169.787 165.355H172.307L176.723 153.259H174.035L171.035 162.307L168.035 153.259H165.371L169.787 165.355ZM189.242 158.851C189.242 155.899 187.178 153.067 183.29 153.067C179.45 153.067 177.386 156.043 177.386 159.307C177.386 162.571 179.57 165.547 183.41 165.547C186.242 165.547 188.306 164.203 188.954 161.875L186.482 161.251C186.17 162.571 185.042 163.315 183.458 163.315C181.538 163.315 180.194 162.019 179.954 159.931H189.194C189.218 159.715 189.242 159.211 189.242 158.851ZM180.074 157.939C180.458 156.139 181.634 155.131 183.29 155.131C185.21 155.131 186.29 156.307 186.458 157.939H180.074ZM199.187 155.803L199.331 153.283C198.971 153.139 198.443 153.067 197.987 153.067C196.523 153.067 194.939 154.123 194.291 155.563V153.259H191.675V165.355H194.291V160.843C194.291 157.099 195.851 155.515 197.627 155.515C198.179 155.515 198.755 155.611 199.187 155.803ZM209.135 153.259L205.895 161.635L202.727 153.259H199.895L204.599 164.995L202.775 169.723H205.463L211.823 153.259H209.135Z"
								fill="#1A1A1A"
							/>
						</svg>
						<svg
							width="312"
							height="312"
							viewBox="0 0 312 312"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								style={{ animationDuration: ".5s" }}
								d="M156.396 0.39624L312 156L156.396 311.604L0.79248 156L156.396 0.39624Z"
								fill="#FEF552"
								opacity={1}
								className={classSquare[1]}
							/>
							<path
								d="M149.413 6.87973L153.735 2.5574L154.442 3.26451L155.896 1.81046L157.35 3.26448L158.057 2.55738L162.38 6.87971L161.673 7.58682L165.995 11.9091L166.702 11.202L171.024 15.5244L170.317 16.2315L174.64 20.5538L175.347 19.8467L179.669 24.169L178.962 24.8761L183.284 29.1985L183.991 28.4914L188.314 32.8137L187.607 33.5208L191.929 37.8431L192.636 37.136L196.958 41.4584L196.251 42.1655L200.574 46.4878L201.281 45.7807L205.603 50.103L204.896 50.8101L209.218 55.1325L209.925 54.4254L214.248 58.7477L213.541 59.4548L217.863 63.7771L218.57 63.07L222.892 67.3924L222.185 68.0995L226.508 72.4218L227.215 71.7147L231.537 76.037L230.83 76.7441L235.152 81.0665L235.859 80.3593L240.182 84.6817L239.475 85.3888L243.797 89.7111L244.504 89.004L248.826 93.3263L248.119 94.0334L252.442 98.3558L253.149 97.6487L257.471 101.971L256.764 102.678L261.086 107L261.793 106.293L266.116 110.616L265.409 111.323L269.731 115.645L270.438 114.938L274.76 119.26L274.053 119.967L278.376 124.29L279.083 123.583L283.405 127.905L282.698 128.612L287.02 132.934L287.727 132.227L292.05 136.55L291.343 137.257L295.665 141.579L296.372 140.872L300.694 145.194L299.987 145.901L304.31 150.224L305.017 149.517L309.339 153.839L308.632 154.546L310.086 156L308.632 157.454L309.339 158.161L305.017 162.484L304.31 161.776L299.987 166.099L300.694 166.806L296.372 171.128L295.665 170.421L291.343 174.743L292.05 175.451L287.727 179.773L287.02 179.066L282.698 183.388L283.405 184.095L279.083 188.418L278.376 187.71L274.053 192.033L274.76 192.74L270.438 197.062L269.731 196.355L265.409 200.677L266.116 201.385L261.793 205.707L261.086 205L256.764 209.322L257.471 210.029L253.149 214.352L252.442 213.644L248.119 217.967L248.826 218.674L244.504 222.996L243.797 222.289L239.475 226.611L240.182 227.319L235.859 231.641L235.152 230.934L230.83 235.256L231.537 235.963L227.215 240.286L226.508 239.578L222.185 243.901L222.892 244.608L218.57 248.93L217.863 248.223L213.541 252.545L214.248 253.252L209.925 257.575L209.218 256.868L204.896 261.19L205.603 261.897L201.281 266.219L200.574 265.512L196.251 269.835L196.958 270.542L192.636 274.864L191.929 274.157L187.607 278.479L188.314 279.186L183.991 283.509L183.284 282.802L178.962 287.124L179.669 287.831L175.347 292.153L174.64 291.446L170.317 295.769L171.024 296.476L166.702 300.798L165.995 300.091L161.673 304.413L162.38 305.12L158.057 309.443L157.35 308.736L155.896 310.19L154.442 308.736L153.735 309.443L149.413 305.12L150.12 304.413L145.798 300.091L145.091 300.798L140.768 296.476L141.475 295.769L137.153 291.446L136.446 292.153L132.124 287.831L132.831 287.124L128.508 282.802L127.801 283.509L123.479 279.186L124.186 278.479L119.864 274.157L119.157 274.864L114.834 270.542L115.541 269.835L111.219 265.512L110.512 266.219L106.19 261.897L106.897 261.19L102.574 256.868L101.867 257.575L97.5449 253.252L98.252 252.545L93.9296 248.223L93.2225 248.93L88.9002 244.608L89.6073 243.901L85.285 239.578L84.5779 240.285L80.2555 235.963L80.9627 235.256L76.6403 230.934L75.9332 231.641L71.6109 227.318L72.318 226.611L67.9957 222.289L67.2886 222.996L62.9662 218.674L63.6733 217.967L59.351 213.644L58.6439 214.352L54.3216 210.029L55.0287 209.322L50.7064 205L49.9993 205.707L45.6769 201.385L46.384 200.677L42.0617 196.355L41.3546 197.062L37.0323 192.74L37.7394 192.033L33.417 187.71L32.7099 188.418L28.3876 184.095L29.0947 183.388L24.7724 179.066L24.0653 179.773L19.743 175.451L20.4501 174.743L16.1277 170.421L15.4206 171.128L11.0983 166.806L11.8054 166.099L7.48308 161.776L6.77597 162.484L2.45364 158.161L3.16075 157.454L1.7067 156L3.16072 154.546L2.45362 153.839L6.77595 149.517L7.48306 150.224L11.8054 145.901L11.0983 145.194L15.4206 140.872L16.1277 141.579L20.45 137.257L19.7429 136.55L24.0653 132.227L24.7724 132.934L29.0947 128.612L28.3876 127.905L32.7099 123.583L33.417 124.29L37.7394 119.967L37.0323 119.26L41.3546 114.938L42.0617 115.645L46.3841 111.323L45.6769 110.616L49.9993 106.293L50.7064 107L55.0287 102.678L54.3216 101.971L58.6439 97.6486L59.351 98.3557L63.6734 94.0334L62.9663 93.3263L67.2886 89.004L67.9957 89.7111L72.318 85.3887L71.6109 84.6816L75.9333 80.3593L76.6404 81.0664L80.9627 76.7441L80.2556 76.037L84.5779 71.7146L85.285 72.4218L89.6073 68.0994L88.9002 67.3923L93.2226 63.07L93.9297 63.7771L98.252 59.4548L97.5449 58.7477L101.867 54.4253L102.574 55.1324L106.897 50.8101L106.19 50.103L110.512 45.7807L111.219 46.4878L115.541 42.1655L114.834 41.4584L119.157 37.136L119.864 37.8431L124.186 33.5208L123.479 32.8137L127.801 28.4914L128.508 29.1985L132.831 24.8762L132.124 24.1691L136.446 19.8467L137.153 20.5538L141.475 16.2315L140.768 15.5244L145.09 11.2021L145.798 11.9092L150.12 7.58684L149.413 6.87973Z"
								stroke="#1A1A1A"
								strokeWidth="2"
								strokeDasharray="6 6"
							/>
							<path
								opacity="1"
								d="M95.4415 165.547C97.6255 165.547 99.5935 164.587 100.361 163.099V165.355H102.905V156.499H94.9135V158.827H100.289C100.145 161.347 98.3215 163.075 95.5375 163.075C92.3935 163.075 90.1375 160.891 90.1375 156.955C90.1375 153.019 92.3935 150.811 95.5615 150.811C98.0095 150.811 99.7615 152.203 100.193 154.411L102.977 153.835C102.329 150.451 99.4975 148.363 95.5855 148.363C91.2895 148.363 87.2815 151.219 87.2815 156.955C87.2815 162.691 91.2175 165.547 95.4415 165.547ZM113.371 155.803L113.515 153.283C113.155 153.139 112.627 153.067 112.171 153.067C110.707 153.067 109.123 154.123 108.475 155.563V153.259H105.859V165.355H108.475V160.843C108.475 157.099 110.035 155.515 111.811 155.515C112.363 155.515 112.939 155.611 113.371 155.803ZM120.497 165.547C124.121 165.547 126.737 162.931 126.737 159.307C126.737 155.683 124.121 153.067 120.497 153.067C116.849 153.067 114.257 155.683 114.257 159.307C114.257 162.931 116.849 165.547 120.497 165.547ZM120.497 163.267C118.337 163.267 116.897 161.635 116.897 159.307C116.897 156.979 118.337 155.347 120.497 155.347C122.633 155.347 124.097 156.979 124.097 159.307C124.097 161.635 122.633 163.267 120.497 163.267ZM140.123 153.259H137.507V158.563C137.507 161.467 136.283 163.195 134.267 163.195C132.731 163.195 131.771 162.139 131.771 160.627V153.259H129.155V161.227C129.155 163.843 130.955 165.547 133.547 165.547C135.299 165.547 136.715 164.635 137.507 163.339V165.355H140.123V153.259ZM143.218 165.355H145.834V160.051C145.834 157.147 147.058 155.419 149.098 155.419C150.634 155.419 151.57 156.475 151.57 157.987V165.355H154.186V157.387C154.186 154.771 152.386 153.067 149.818 153.067C148.042 153.067 146.65 153.979 145.834 155.275V153.259H143.218V165.355ZM162.393 165.547C164.001 165.547 165.465 164.827 166.041 163.819V165.355H168.657V148.363H166.041V154.771C165.321 153.763 163.905 153.067 162.345 153.067C158.697 153.067 156.609 155.659 156.609 159.307C156.609 162.955 158.697 165.547 162.393 165.547ZM162.729 163.267C160.617 163.267 159.225 161.683 159.225 159.307C159.225 156.907 160.617 155.347 162.729 155.347C164.841 155.347 166.233 156.907 166.233 159.307C166.233 161.683 164.841 163.267 162.729 163.267ZM174.525 165.355H176.925L179.541 156.931L182.157 165.355H184.581L188.301 153.259H185.637L183.357 161.707L180.765 153.259H178.341L175.725 161.707L173.445 153.259H170.781L174.525 165.355ZM195.615 165.547C199.239 165.547 201.855 162.931 201.855 159.307C201.855 155.683 199.239 153.067 195.615 153.067C191.967 153.067 189.375 155.683 189.375 159.307C189.375 162.931 191.967 165.547 195.615 165.547ZM195.615 163.267C193.455 163.267 192.015 161.635 192.015 159.307C192.015 156.979 193.455 155.347 195.615 155.347C197.751 155.347 199.215 156.979 199.215 159.307C199.215 161.635 197.751 163.267 195.615 163.267ZM211.785 155.803L211.929 153.283C211.569 153.139 211.041 153.067 210.585 153.067C209.121 153.067 207.537 154.123 206.889 155.563V153.259H204.273V165.355H206.889V160.843C206.889 157.099 208.449 155.515 210.225 155.515C210.777 155.515 211.353 155.611 211.785 155.803ZM221.996 165.355H225.188L219.788 158.035L224.804 153.259H221.42L216.428 157.819V148.363H213.788V165.355H216.428V161.203L217.94 159.787L221.996 165.355Z"
								fill="#1A1A1A"
							/>
						</svg>
						<svg
							width="312"
							height="312"
							viewBox="0 0 312 312"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								style={{ animationDuration: ".5s" }}
								d="M156.396 0.39624L312 156L156.396 311.604L0.79248 156L156.396 0.39624Z"
								fill="#87FA97"
								opacity={1}
								className={classSquare[2]}
							/>
							<path
								d="M149.705 6.87973L154.027 2.5574L154.734 3.26451L156.188 1.81046L157.642 3.26448L158.349 2.55738L162.672 6.87971L161.965 7.58682L166.287 11.9091L166.994 11.202L171.316 15.5244L170.609 16.2315L174.932 20.5538L175.639 19.8467L179.961 24.169L179.254 24.8761L183.576 29.1985L184.283 28.4914L188.606 32.8137L187.899 33.5208L192.221 37.8431L192.928 37.136L197.25 41.4584L196.543 42.1655L200.866 46.4878L201.573 45.7807L205.895 50.103L205.188 50.8101L209.51 55.1325L210.217 54.4254L214.54 58.7477L213.833 59.4548L218.155 63.7771L218.862 63.07L223.184 67.3924L222.477 68.0995L226.8 72.4218L227.507 71.7147L231.829 76.037L231.122 76.7441L235.444 81.0665L236.151 80.3593L240.474 84.6817L239.767 85.3888L244.089 89.7111L244.796 89.004L249.118 93.3263L248.411 94.0334L252.734 98.3558L253.441 97.6487L257.763 101.971L257.056 102.678L261.378 107L262.085 106.293L266.408 110.616L265.701 111.323L270.023 115.645L270.73 114.938L275.052 119.26L274.345 119.967L278.668 124.29L279.375 123.583L283.697 127.905L282.99 128.612L287.312 132.934L288.019 132.227L292.342 136.55L291.635 137.257L295.957 141.579L296.664 140.872L300.986 145.194L300.279 145.901L304.602 150.224L305.309 149.517L309.631 153.839L308.924 154.546L310.378 156L308.924 157.454L309.631 158.161L305.309 162.484L304.602 161.776L300.279 166.099L300.986 166.806L296.664 171.128L295.957 170.421L291.635 174.743L292.342 175.451L288.019 179.773L287.312 179.066L282.99 183.388L283.697 184.095L279.375 188.418L278.668 187.71L274.345 192.033L275.052 192.74L270.73 197.062L270.023 196.355L265.701 200.677L266.408 201.385L262.085 205.707L261.378 205L257.056 209.322L257.763 210.029L253.441 214.352L252.734 213.644L248.411 217.967L249.118 218.674L244.796 222.996L244.089 222.289L239.767 226.611L240.474 227.319L236.151 231.641L235.444 230.934L231.122 235.256L231.829 235.963L227.507 240.286L226.8 239.578L222.477 243.901L223.184 244.608L218.862 248.93L218.155 248.223L213.833 252.545L214.54 253.252L210.217 257.575L209.51 256.868L205.188 261.19L205.895 261.897L201.573 266.219L200.866 265.512L196.543 269.835L197.25 270.542L192.928 274.864L192.221 274.157L187.899 278.479L188.606 279.186L184.283 283.509L183.576 282.802L179.254 287.124L179.961 287.831L175.639 292.153L174.932 291.446L170.609 295.769L171.316 296.476L166.994 300.798L166.287 300.091L161.965 304.413L162.672 305.12L158.349 309.443L157.642 308.736L156.188 310.19L154.734 308.736L154.027 309.443L149.705 305.12L150.412 304.413L146.09 300.091L145.383 300.798L141.06 296.476L141.767 295.769L137.445 291.446L136.738 292.153L132.415 287.831L133.123 287.124L128.8 282.802L128.093 283.509L123.771 279.186L124.478 278.479L120.156 274.157L119.449 274.864L115.126 270.542L115.833 269.835L111.511 265.512L110.804 266.219L106.482 261.897L107.189 261.19L102.866 256.868L102.159 257.575L97.8369 253.252L98.544 252.545L94.2216 248.223L93.5145 248.93L89.1922 244.608L89.8993 243.901L85.577 239.578L84.8699 240.285L80.5475 235.963L81.2546 235.256L76.9323 230.934L76.2252 231.641L71.9029 227.318L72.61 226.611L68.2877 222.289L67.5806 222.996L63.2582 218.674L63.9653 217.967L59.643 213.644L58.9359 214.352L54.6136 210.029L55.3207 209.322L50.9984 205L50.2912 205.707L45.9689 201.385L46.676 200.677L42.3537 196.355L41.6466 197.062L37.3243 192.74L38.0314 192.033L33.709 187.71L33.0019 188.418L28.6796 184.095L29.3867 183.388L25.0644 179.066L24.3573 179.773L20.035 175.451L20.7421 174.743L16.4197 170.421L15.7126 171.128L11.3903 166.806L12.0974 166.099L7.77507 161.776L7.06796 162.484L2.74564 158.161L3.45274 157.454L1.99869 156L3.45272 154.546L2.74561 153.839L7.06794 149.517L7.77505 150.224L12.0974 145.901L11.3903 145.194L15.7126 140.872L16.4197 141.579L20.742 137.257L20.0349 136.55L24.3573 132.227L25.0644 132.934L29.3867 128.612L28.6796 127.905L33.0019 123.583L33.709 124.29L38.0314 119.967L37.3243 119.26L41.6466 114.938L42.3537 115.645L46.676 111.323L45.9689 110.616L50.2913 106.293L50.9984 107L55.3207 102.678L54.6136 101.971L58.9359 97.6486L59.643 98.3557L63.9654 94.0334L63.2583 93.3263L67.5806 89.004L68.2877 89.7111L72.61 85.3887L71.9029 84.6816L76.2252 80.3593L76.9324 81.0664L81.2547 76.7441L80.5476 76.037L84.8699 71.7146L85.577 72.4218L89.8993 68.0994L89.1922 67.3923L93.5146 63.07L94.2217 63.7771L98.544 59.4548L97.8369 58.7477L102.159 54.4253L102.866 55.1324L107.189 50.8101L106.482 50.103L110.804 45.7807L111.511 46.4878L115.833 42.1655L115.126 41.4584L119.449 37.136L120.156 37.8431L124.478 33.5208L123.771 32.8137L128.093 28.4914L128.8 29.1985L133.123 24.8762L132.415 24.1691L136.738 19.8467L137.445 20.5538L141.767 16.2315L141.06 15.5244L145.382 11.2021L146.09 11.9092L150.412 7.58684L149.705 6.87973Z"
								stroke="#1A1A1A"
								strokeWidth="2"
								strokeDasharray="6 6"
							/>
							<path
								opacity="1"
								d="M113.672 165.355H116.576L110.024 148.555H107.408L100.88 165.355H103.784L105.272 161.395H112.184L113.672 165.355ZM106.184 158.971L108.728 152.251L111.272 158.971H106.184ZM123.468 165.547C126.42 165.547 128.508 164.035 129.012 161.515L126.444 161.011C126.156 162.427 125.076 163.267 123.54 163.267C121.476 163.267 120.108 161.707 120.108 159.307C120.108 156.907 121.452 155.347 123.54 155.347C125.076 155.347 126.204 156.283 126.444 157.651L128.988 157.147C128.58 154.651 126.444 153.067 123.468 153.067C119.844 153.067 117.396 155.587 117.396 159.307C117.396 163.027 119.844 165.547 123.468 165.547ZM138.057 165.259L137.889 162.931C137.433 163.147 136.881 163.219 136.425 163.219C135.441 163.219 134.769 162.595 134.769 161.395V155.491H137.889V153.259H134.769V149.659H132.153V153.259H130.041V155.491H132.153V161.539C132.153 164.299 133.857 165.547 136.137 165.547C136.809 165.547 137.481 165.451 138.057 165.259ZM141.559 151.243C142.543 151.243 143.287 150.499 143.287 149.563C143.287 148.603 142.543 147.859 141.559 147.859C140.599 147.859 139.879 148.603 139.879 149.563C139.879 150.499 140.599 151.243 141.559 151.243ZM140.263 165.355H142.879V153.259H140.263V165.355ZM149.102 165.355H151.622L156.038 153.259H153.35L150.35 162.307L147.35 153.259H144.686L149.102 165.355ZM162.051 153.067C159.483 153.067 157.419 154.627 157.035 157.003L159.387 157.435C159.555 155.995 160.587 155.131 162.051 155.131C163.635 155.131 164.667 156.043 164.667 157.531V157.699L162.387 157.939C158.667 158.323 156.819 159.595 156.819 161.971C156.819 164.035 158.475 165.547 160.875 165.547C162.483 165.547 163.971 164.731 164.667 163.507V165.355H167.235V157.819C167.235 154.795 165.123 153.067 162.051 153.067ZM161.403 163.531C160.179 163.531 159.387 162.859 159.387 161.899C159.387 160.843 160.395 160.123 162.363 159.907L164.667 159.643V160.147C164.643 162.115 163.443 163.531 161.403 163.531ZM177.01 165.259L176.842 162.931C176.386 163.147 175.834 163.219 175.378 163.219C174.394 163.219 173.722 162.595 173.722 161.395V155.491H176.842V153.259H173.722V149.659H171.106V153.259H168.994V155.491H171.106V161.539C171.106 164.299 172.81 165.547 175.09 165.547C175.762 165.547 176.434 165.451 177.01 165.259ZM180.512 151.243C181.496 151.243 182.24 150.499 182.24 149.563C182.24 148.603 181.496 147.859 180.512 147.859C179.552 147.859 178.832 148.603 178.832 149.563C178.832 150.499 179.552 151.243 180.512 151.243ZM179.216 165.355H181.832V153.259H179.216V165.355ZM190.527 165.547C194.151 165.547 196.767 162.931 196.767 159.307C196.767 155.683 194.151 153.067 190.527 153.067C186.879 153.067 184.287 155.683 184.287 159.307C184.287 162.931 186.879 165.547 190.527 165.547ZM190.527 163.267C188.367 163.267 186.927 161.635 186.927 159.307C186.927 156.979 188.367 155.347 190.527 155.347C192.663 155.347 194.127 156.979 194.127 159.307C194.127 161.635 192.663 163.267 190.527 163.267ZM199.185 165.355H201.801V160.051C201.801 157.147 203.025 155.419 205.065 155.419C206.601 155.419 207.537 156.475 207.537 157.987V165.355H210.153V157.387C210.153 154.771 208.353 153.067 205.785 153.067C204.009 153.067 202.617 153.979 201.801 155.275V153.259H199.185V165.355Z"
								fill="#1A1A1A"
							/>
						</svg>
						<svg
							width="312"
							height="312"
							viewBox="0 0 312 312"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								style={{ animationDuration: ".5s" }}
								d="M156.396 0.39624L312 156L156.396 311.604L0.79248 156L156.396 0.39624Z"
								fill="#62B8F9"
								opacity={1}
								className={classSquare[3]}
							/>
							<path
								d="M149.913 6.87973L154.235 2.5574L154.942 3.26451L156.396 1.81046L157.85 3.26448L158.557 2.55738L162.88 6.87971L162.173 7.58682L166.495 11.9091L167.202 11.202L171.524 15.5244L170.817 16.2315L175.14 20.5538L175.847 19.8467L180.169 24.169L179.462 24.8761L183.784 29.1985L184.491 28.4914L188.814 32.8137L188.107 33.5208L192.429 37.8431L193.136 37.136L197.458 41.4584L196.751 42.1655L201.074 46.4878L201.781 45.7807L206.103 50.103L205.396 50.8101L209.718 55.1325L210.425 54.4254L214.748 58.7477L214.041 59.4548L218.363 63.7771L219.07 63.07L223.392 67.3924L222.685 68.0995L227.008 72.4218L227.715 71.7147L232.037 76.037L231.33 76.7441L235.652 81.0665L236.359 80.3593L240.682 84.6817L239.975 85.3888L244.297 89.7111L245.004 89.004L249.326 93.3263L248.619 94.0334L252.942 98.3558L253.649 97.6487L257.971 101.971L257.264 102.678L261.586 107L262.293 106.293L266.616 110.616L265.909 111.323L270.231 115.645L270.938 114.938L275.26 119.26L274.553 119.967L278.876 124.29L279.583 123.583L283.905 127.905L283.198 128.612L287.52 132.934L288.227 132.227L292.55 136.55L291.843 137.257L296.165 141.579L296.872 140.872L301.194 145.194L300.487 145.901L304.81 150.224L305.517 149.517L309.839 153.839L309.132 154.546L310.586 156L309.132 157.454L309.839 158.161L305.517 162.484L304.81 161.776L300.487 166.099L301.194 166.806L296.872 171.128L296.165 170.421L291.843 174.743L292.55 175.451L288.227 179.773L287.52 179.066L283.198 183.388L283.905 184.095L279.583 188.418L278.876 187.71L274.553 192.033L275.26 192.74L270.938 197.062L270.231 196.355L265.909 200.677L266.616 201.385L262.293 205.707L261.586 205L257.264 209.322L257.971 210.029L253.649 214.352L252.942 213.644L248.619 217.967L249.326 218.674L245.004 222.996L244.297 222.289L239.975 226.611L240.682 227.319L236.359 231.641L235.652 230.934L231.33 235.256L232.037 235.963L227.715 240.286L227.008 239.578L222.685 243.901L223.392 244.608L219.07 248.93L218.363 248.223L214.041 252.545L214.748 253.252L210.425 257.575L209.718 256.868L205.396 261.19L206.103 261.897L201.781 266.219L201.074 265.512L196.751 269.835L197.458 270.542L193.136 274.864L192.429 274.157L188.107 278.479L188.814 279.186L184.491 283.509L183.784 282.802L179.462 287.124L180.169 287.831L175.847 292.153L175.14 291.446L170.817 295.769L171.524 296.476L167.202 300.798L166.495 300.091L162.173 304.413L162.88 305.12L158.557 309.443L157.85 308.736L156.396 310.19L154.942 308.736L154.235 309.443L149.913 305.12L150.62 304.413L146.298 300.091L145.591 300.798L141.268 296.476L141.975 295.769L137.653 291.446L136.946 292.153L132.624 287.831L133.331 287.124L129.008 282.802L128.301 283.509L123.979 279.186L124.686 278.479L120.364 274.157L119.657 274.864L115.334 270.542L116.041 269.835L111.719 265.512L111.012 266.219L106.69 261.897L107.397 261.19L103.074 256.868L102.367 257.575L98.0449 253.252L98.752 252.545L94.4296 248.223L93.7225 248.93L89.4002 244.608L90.1073 243.901L85.785 239.578L85.0779 240.285L80.7555 235.963L81.4627 235.256L77.1403 230.934L76.4332 231.641L72.1109 227.318L72.818 226.611L68.4957 222.289L67.7886 222.996L63.4662 218.674L64.1733 217.967L59.851 213.644L59.1439 214.352L54.8216 210.029L55.5287 209.322L51.2064 205L50.4993 205.707L46.1769 201.385L46.884 200.677L42.5617 196.355L41.8546 197.062L37.5323 192.74L38.2394 192.033L33.917 187.71L33.2099 188.418L28.8876 184.095L29.5947 183.388L25.2724 179.066L24.5653 179.773L20.243 175.451L20.9501 174.743L16.6277 170.421L15.9206 171.128L11.5983 166.806L12.3054 166.099L7.98308 161.776L7.27597 162.484L2.95364 158.161L3.66075 157.454L2.2067 156L3.66072 154.546L2.95362 153.839L7.27595 149.517L7.98306 150.224L12.3054 145.901L11.5983 145.194L15.9206 140.872L16.6277 141.579L20.95 137.257L20.2429 136.55L24.5653 132.227L25.2724 132.934L29.5947 128.612L28.8876 127.905L33.2099 123.583L33.917 124.29L38.2394 119.967L37.5323 119.26L41.8546 114.938L42.5617 115.645L46.8841 111.323L46.1769 110.616L50.4993 106.293L51.2064 107L55.5287 102.678L54.8216 101.971L59.1439 97.6486L59.851 98.3557L64.1734 94.0334L63.4663 93.3263L67.7886 89.004L68.4957 89.7111L72.818 85.3887L72.1109 84.6816L76.4333 80.3593L77.1404 81.0664L81.4627 76.7441L80.7556 76.037L85.0779 71.7146L85.785 72.4218L90.1073 68.0994L89.4002 67.3923L93.7226 63.07L94.4297 63.7771L98.752 59.4548L98.0449 58.7477L102.367 54.4253L103.074 55.1324L107.397 50.8101L106.69 50.103L111.012 45.7807L111.719 46.4878L116.041 42.1655L115.334 41.4584L119.657 37.136L120.364 37.8431L124.686 33.5208L123.979 32.8137L128.301 28.4914L129.008 29.1985L133.331 24.8762L132.624 24.1691L136.946 19.8467L137.653 20.5538L141.975 16.2315L141.268 15.5244L145.59 11.2021L146.298 11.9092L150.62 7.58684L149.913 6.87973Z"
								stroke="#1A1A1A"
								strokeWidth="2"
								strokeDasharray="6 6"
							/>
							<path
								opacity="1"
								d="M116.979 165.547C120.843 165.547 123.483 163.339 123.483 159.379V148.555H120.819V159.427C120.819 161.779 119.259 163.075 116.979 163.075C114.675 163.075 113.115 161.779 113.115 159.427V148.555H110.451V159.379C110.451 163.339 113.091 165.547 116.979 165.547ZM126.667 169.723H129.283V163.963C130.027 164.923 131.443 165.547 132.907 165.547C136.531 165.547 138.739 162.955 138.739 159.307C138.739 155.659 136.627 153.067 133.051 153.067C131.371 153.067 129.955 153.811 129.283 154.795V153.259H126.667V169.723ZM132.619 163.267C130.507 163.267 129.115 161.683 129.115 159.307C129.115 156.907 130.507 155.347 132.619 155.347C134.731 155.347 136.123 156.907 136.123 159.307C136.123 161.683 134.731 163.267 132.619 163.267ZM149.744 153.259V154.651C149.048 153.715 147.656 153.067 146.12 153.067C142.568 153.067 140.504 155.539 140.504 159.043C140.504 162.547 142.568 165.019 146.168 165.019C147.752 165.019 149.168 164.395 149.768 163.483V164.947C149.768 166.627 148.424 167.779 146.48 167.779C144.896 167.779 143.624 166.987 143.48 165.787L141.032 166.195C141.416 168.403 143.648 169.915 146.48 169.915C149.96 169.915 152.336 167.803 152.336 164.683V153.259H149.744ZM146.528 162.739C144.464 162.739 143.12 161.275 143.12 159.043C143.12 156.811 144.464 155.347 146.528 155.347C148.568 155.347 149.912 156.811 149.912 159.043C149.912 161.275 148.568 162.739 146.528 162.739ZM162.914 155.803L163.058 153.283C162.698 153.139 162.17 153.067 161.714 153.067C160.25 153.067 158.666 154.123 158.018 155.563V153.259H155.402V165.355H158.018V160.843C158.018 157.099 159.578 155.515 161.354 155.515C161.906 155.515 162.482 155.611 162.914 155.803ZM169.15 153.067C166.582 153.067 164.518 154.627 164.134 157.003L166.486 157.435C166.654 155.995 167.686 155.131 169.15 155.131C170.734 155.131 171.766 156.043 171.766 157.531V157.699L169.486 157.939C165.766 158.323 163.918 159.595 163.918 161.971C163.918 164.035 165.574 165.547 167.974 165.547C169.582 165.547 171.07 164.731 171.766 163.507V165.355H174.334V157.819C174.334 154.795 172.222 153.067 169.15 153.067ZM168.502 163.531C167.278 163.531 166.486 162.859 166.486 161.899C166.486 160.843 167.494 160.123 169.462 159.907L171.766 159.643V160.147C171.742 162.115 170.542 163.531 168.502 163.531ZM182.545 165.547C184.153 165.547 185.617 164.827 186.193 163.819V165.355H188.809V148.363H186.193V154.771C185.473 153.763 184.057 153.067 182.497 153.067C178.849 153.067 176.761 155.659 176.761 159.307C176.761 162.955 178.849 165.547 182.545 165.547ZM182.881 163.267C180.769 163.267 179.377 161.683 179.377 159.307C179.377 156.907 180.769 155.347 182.881 155.347C184.993 155.347 186.385 156.907 186.385 159.307C186.385 161.683 184.993 163.267 182.881 163.267ZM203.102 158.851C203.102 155.899 201.038 153.067 197.15 153.067C193.31 153.067 191.246 156.043 191.246 159.307C191.246 162.571 193.43 165.547 197.27 165.547C200.102 165.547 202.166 164.203 202.814 161.875L200.342 161.251C200.03 162.571 198.902 163.315 197.318 163.315C195.398 163.315 194.054 162.019 193.814 159.931H203.054C203.078 159.715 203.102 159.211 203.102 158.851ZM193.934 157.939C194.318 156.139 195.494 155.131 197.15 155.131C199.07 155.131 200.15 156.307 200.318 157.939H193.934Z"
								fill="#1A1A1A"
							/>
						</svg>
					</div>

					{touchWork() && (
						<div className="arrows">
							<button className="arrow-button">
								<img
									className={indexTexts === 0 ? "disabled" : ""}
									onClick={handleGoPrev}
									src={icons.arrow.circle.left}
									alt="Go prev"
								/>
							</button>
							<button className="arrow-button">
								<img
									onClick={handleGoNext}
									src={icons.arrow.circle.right}
									alt="Go next"
								/>
							</button>
						</div>
					)}
				</ContainerBlock>
			</FullHeightSection>
		<div className="cta-single-project">
						<div className="cta-single-project-inner">
							<p>{translations && translations.ctaapproach.text}</p>
							<button
								className="leadconnector-button"
								onClick={() => {
									const overlay = document.createElement('div');
									overlay.style.cssText = `
										position: fixed;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
										background-color: rgba(0, 0, 0, 0.7);
										backdrop-filter: blur(5px);
										z-index: 9998;
									`;
									
									const modal = document.createElement('div');
									modal.style.cssText = `
										position: fixed;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
										z-index: 9999;
									`;
									
									const closeBtn = document.createElement('button');
									closeBtn.innerHTML = '✕';
									closeBtn.style.cssText = `
										position: fixed;
										top: 30px;
										right: 30px;
										width: 50px;
										height: 50px;
										border: none;
										background-color: rgba(255, 255, 255, 0.2);
										color: white;
										border-radius: 50%;
										cursor: pointer;
										font-size: 28px;
										z-index: 10000;
										transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
										backdrop-filter: blur(10px);
										border: 1px solid rgba(255, 255, 255, 0.3);
										display: flex;
										align-items: center;
										justify-content: center;
									`;
									closeBtn.onmouseover = () => {
										closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
										closeBtn.style.transform = 'scale(1.15) rotate(90deg)';
										closeBtn.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3)';
										closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.5)';
									};
									closeBtn.onmouseout = () => {
										closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
										closeBtn.style.transform = 'scale(1) rotate(0deg)';
										closeBtn.style.boxShadow = 'none';
										closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.3)';
									};
									closeBtn.onclick = () => {
										overlay.style.opacity = '0';
										modal.style.opacity = '0';
										overlay.style.transition = 'opacity 0.4s ease-out';
										modal.style.transition = 'opacity 0.4s ease-out';
										setTimeout(() => {
											document.body.removeChild(overlay);
											document.body.removeChild(modal);
										}, 400);
									};
									
									const iframe = document.createElement('iframe');
									iframe.src = 'https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true';
									iframe.style.cssText = `
										width: 100%;
										height: 100%;
										border: none;
									`;
									iframe.allowFullscreen = true;
									
									modal.appendChild(iframe);
									modal.appendChild(closeBtn);
									document.body.appendChild(overlay);
									document.body.appendChild(modal);
									
									overlay.onclick = () => {
										document.body.removeChild(overlay);
										document.body.removeChild(modal);
									};
								}}
							>
								{translations && translations.ctaapproach.button}
							</button>
						</div>
					</div>
		</section>
	);
};

export default Approach;
